export default {
  SUPPORT_EMAIL: 'support@plentifulapp.com',
  TITLE: 'Plentiful for Neighbors',
  STORE_REVIEW_URLS: {
    ios: 'itms-apps://itunes.apple.com/app/id1552756054?action=write-review',
    android: 'https://play.google.com/store/apps/details?id=com.plentifulapp.mobile',
  },
};
